(function TripSummaryTravelers($, Adzuki)
{
	'use strict';

	const component = {
		emits: [
			'addTraveler',
			'removeTraveler',
			'setPrimaryTraveler',
		],
		inject: [
			'getFaIconStyle',
		],
		props: {
			travelers: {
				type   : Array,
				default: [],
			},
			formId: {
				type   : String,
				default: '',
			},
		},
		template: '#ts-travelers',
		data() {
			return {
				clients        : [],
				households     : [],
				openSearch     : false,
				openSuggestions: false,
				searchTerm     : '',
				showSpinner    : false,
			};
		},
		computed: {
			formName() {
				return 'form_component_data[Save]';
			},
		},
		methods: {
			addHousehold(household) {
				// find the household and add all of the clients as travelers
				const foundHousehold = this.households.find(h => h.id === household.id);

				if (foundHousehold) {
					for (const client of foundHousehold.clients) {
						this.addTraveler(client.id, client.name, false);
					}
				}

				this.resetSearch();
			},
			addTraveler(client_id, name, reset = true) {
				this.$emit('addTraveler', client_id, name);

				if (reset) {
					this.resetSearch();
				}
			},
			closeSearch() {
				this.openSearch      = false;
				this.openSuggestions = false;
				this.showSpinner     = false;
			},
			// the shared toast (MEDIA-333), not the layout's old #liveToast
			openToast(message) {
				Adzuki.Toast('success', message);
			},
			performSearch(e) {
				const search = Adzuki.Debounce(async () => {
					if (this.searchTerm.length < 3) {
						this.openSearch = false;
						this.openSuggestions = false;
						return;
					}

					this.showSpinner     = true;
					this.openSuggestions = false;

					try {
						const response = await Adzuki.Ajax.get('/main/travelerSearch/' + this.searchTerm);

						if (response.error) {
							return Adzuki.StatusMessage('error', `Error searching for clients: ${response.error}`);
						}

						this.clients    = response.clients;
						this.households = response.households;
						this.openSearch = true;
					} catch (error) {
						this.openSearch = false;
						Adzuki.StatusMessage('error', `Error searching for clients: ${error.message}`);
					} finally {
						this.showSpinner = false;
					}
				}, 500);

				search();
			},
			async performSuggestions(e) {
				if (this.searchTerm.length > 0) {
					return;
				}

				if (
					!this.travelers ||
					this.travelers.length === 0
				) {
					return;
				}

				this.showSpinner     = true;
				this.openSuggestions = true;
				let client_ids       = [];

				for (const traveler of this.travelers) {
					client_ids.push(traveler.client_id);
				}

				try {
					const response = await Adzuki.Ajax.post('/main/recommendedTravelers', {
						client_ids: client_ids,
					});

					if (response.error) {
						return Adzuki.StatusMessage('error', `Error getting recommended travelers: ${response.error}`);
					}

					this.clients    = response.clients;
					this.households = response.households;
				} catch (error) {
					this.showSpinner = false;
					Adzuki.StatusMessage('error', `Error getting recommended travelers: ${error.message}`);
				} finally {
					this.showSpinner = false;
				}
			},
			removeTraveler(traveler) {
				this.$emit('removeTraveler', traveler);
			},
			resetSearch() {
				this.searchTerm      = '';
				this.clients         = [];
				this.households      = [];
				this.showSpinner     = false;
				this.openSearch      = false;
				this.openSuggestions = false;
			},
			setPrimaryTraveler(traveler) {
				this.$emit('setPrimaryTraveler', traveler);

				this.openToast(traveler.name + ' is now the primary traveler.');
			},
		},
		mounted() {
			// if the user clicks outside of the search container, close the search
			document.addEventListener('click', (event) => {
				if (!this.$refs.searchContainer.contains(event.target)) {
					this.closeSearch();
				}
			});
		},
	};

	Adzuki.VueComponents.TripSummaryTravelers = component;
}(jQuery, window.Adzuki || {}));
